import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { bonos } from '../../data/programa';
export function Bonuses() {
  return <section id="bonos" className="border-b border-line bg-navy py-[60px] lg:py-[100px]" data-id="element-43" data-mp="1hi69dmrp0r98">
      <div className="mx-auto max-w-content px-6 text-center lg:px-10" data-id="element-44" data-mp="1clfwt9f3kdsk">
        <Reveal className="mx-auto max-w-2xl" data-id="element-45" data-mp="18kvwjwz88u27">
          <h2 className="flex items-center justify-center gap-3 text-3xl font-bold leading-tight tracking-tight text-ice sm:text-4xl" data-id="element-46" data-mp="259v6dgfgm3wi">
            <GiftIcon className="h-8 w-8 shrink-0 text-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-47" data-mp="20aihyr8xwort" />
            6 Bonos Estratégicos
          </h2>
          <p className="mt-4 text-[12px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-48" data-mp="1wb9rbv97570h">
            Siempre incluidos
          </p>
        </Reveal>

        <ul className="mx-auto mt-10 grid max-w-5xl gap-4 text-left md:grid-cols-2 lg:grid-cols-3" data-id="element-49" data-mp="kv1lnkygxfkl">
          {bonos.map((bono, index) => <Reveal key={bono.number} delay={index * 0.04} as="li" className="h-full" data-id="element-50" data-mp="ftlztqogv515" data-mpi={index}>
              <div className="flex h-full flex-col rounded-2xl border border-gold bg-white/[0.04] p-5 backdrop-blur-[10px]" data-id="element-51" data-mp="1euybvz40a39o">
                <span className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-gold/50 bg-line text-[11px] font-bold text-gold" data-id="element-52" data-mp="1jqng4fqz08cb">
                  {bono.number}
                </span>
                <h3 className="mt-3.5 text-[15px] font-semibold leading-snug text-ice" data-id="element-53" data-mp="w35m0dk8gy66">
                  {bono.title}
                </h3>
                <p className="mt-1.5 flex-1 text-[13px] leading-[1.55] text-cool" data-id="element-54" data-mp="10uxeitmy9dyy">
                  {bono.description}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-line pt-3" data-id="element-55" data-mp="n0e7u5zz3oau">
                  <span className="text-[13px] text-cool line-through" data-id="element-56" data-mp="r1zs4ceu74v2">
                    {bono.price}
                  </span>
                  <span className="text-[11px] font-bold uppercase tracking-[0.1em] text-gold" data-id="element-57" data-mp="i34jyus8fkp4">
                    Gratis
                  </span>
                </div>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} className="mx-auto mt-12 max-w-2xl" data-id="element-58" data-mp="2f1lbl7lpfz9v">
          <div className="rounded-2xl border border-gold bg-white/[0.04] px-8 py-6 backdrop-blur-[10px]" data-id="element-59" data-mp="2b09md36qtg27">
            <p className="text-[17px] text-cool" data-id="element-60" data-mp="261f3k18rzri3">
              Valor total de los bonos{' '}
              <span className="line-through" data-id="element-61" data-mp="32rfsq1d249zx">$56.000</span> →{' '}
              <span className="text-xl font-bold uppercase tracking-[0.05em] text-gold" data-id="element-62" data-mp="32qmq9cl4s6nl">
                GRATIS
              </span>{' '}
              con tu Programa Atleta Corporativo
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}